// Batch upload panel (Media page and the photo picker's Upload tab) and the leave dialog
// shown while a batch is uploading. The `leave` block belongs to the leave guard; the rest
// belongs to the panel (`components/media/upload/BatchUploadPanel.tsx`).
export const mediaUpload = {
  dropHint: "Drag photos or a whole folder here",
  addMore: "Add more",
  chooseFiles: "Choose files",
  chooseFolder: "Choose folder",
  rejected: "Files not added: {{count}} — they are not photos.",
  countries: "Countries",
  source: "Source",
  sourceHint:
    "Author or photo bank; the list offers earlier sources. An existing photo gets the source only when it has none.",
  sourceHintPicker: "Author or photo bank; the list offers earlier sources.",
  start_one: "Upload {{count}} file",
  start_few: "Upload {{count}} files",
  start_other: "Upload {{count}} files",
  cancel: "Cancel",
  finish: "Done",
  remove: "Remove {{name}}",
  resized: "resized to {{px}} px",
  inGallery: "In gallery",
  openExisting: "Open photo",
  restore: "Restore from trash",
  retry: "Try again",
  retryAll: "Retry all failed",
  errorGeneric: "Upload failed.",
  status: {
    queued: "Waiting",
    checking: "Checking",
    preparing: "Preparing",
    uploading: "Uploading",
    done: "Done",
    duplicateLive: "Already in library",
    duplicateTrash: "In trash",
    duplicateInBatch: "Same file is in the batch",
    error: "Error",
    errorPermanent: "Cannot upload",
  },
  permanent: {
    tif: "Open the TIF in Safari, or convert it to JPG",
    heic: "This browser cannot resize a HEIC over {{limit}}: open it in Safari, or convert it to JPG",
  },
  summary: {
    done: "Done: {{count}}",
    existing: "Already in library: {{count}}",
    errors: "Errors: {{count}}",
  },
  leave: {
    title: "Upload still in progress",
    text: "Some photos have not finished uploading. If you leave now, the ones still waiting will not be uploaded.",
    stay: "Stay",
    go: "Leave",
  },
};
